import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { PortraitCard } from "../../components/molecules/cards";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { _superstarRails } from "./optics";
import styles from "./styles.css";
import { _ColAttributes2Title } from "@discovery/sonic-api-ng-optics";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { useWindowSize } from "../../utils/hooks";
const getProps = (data) => {
    const superstarRails = Fold.toArray(_superstarRails, data);
    const titleM = Fold.preview(Fold.compose(_ColAttributes2Title, M._Just()), data);
    return { superstarRails, titleM };
};
const SuperStarRails = ({ superstarRails, titleM }) => {
    const [width] = useWindowSize();
    return (React.createElement("div", { className: styles.container },
        React.createElement(RenderMaybe, null, M.map((title) => (React.createElement("div", { className: styles.title }, title)), titleM)),
        width > 700 ? (React.createElement("div", { className: styles.desktopRailWarpper }, superstarRails.map((card, index) => (React.createElement(PortraitCard, Object.assign({}, card, { id: `#card${index}` })))))) : (React.createElement("div", { className: styles.mobileRailWrapper }, superstarRails.map((card, index) => (React.createElement(PortraitCard, Object.assign({}, card, { id: `#card${index}` }))))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, SuperStarRails);

